<template>
  <div class="content">
    <template v-if="list && list.length">
      <div class="header">
        <el-select v-model="currentIndex" @change="movChange">
          <el-option v-for="(item, ind) in list" :label="item.deviceName + '(' + item.deviceNumber + ')'" :value="ind.toString()" :key="'i' + ind"></el-option>
        </el-select>
        <div class="status">
          <p>设备状态：
            <template v-if="movDetail && movDetail.deviceStatus">
              <template v-if="movDetail.deviceStatus === '1'">
                <i class="iconfont icon-tingzhi"></i>在线
              </template>
              <template v-else>
                <i class="iconfont icon-tingzhi offline"></i>离线
              </template>
            </template>
            <template v-else>--</template>
          </p>
          <p>运行状态：
            <template v-if="movDetail && movDetail.runState && ['0', '1', '2', '3', '4', '5'].includes(movDetail.runState)">
              <span :class="{ style1: ['1', '2'].includes(movDetail.runState), style2: movDetail.runState === '3', style3: movDetail.runState === '5' }">{{runStatusList[Number(movDetail.runState)]}}</span>
            </template>
            <template v-else>--</template>
          </p>
        </div>
      </div>
      <template v-if="movDetail.deviceNumber" >
        <div class="controlBoard">
          <div class="item-header">
            <p class="name">雨天作业</p>
            <el-switch
              v-model="movDetail.rainStatus"
              active-color="#45db5e"
              inactive-color="var(--switch-inactive-color)"
              @change="onAction('', 'rain')">
            </el-switch>
          </div>
          <div class="item-header">
            <p class="name">LED灯</p>
            <el-switch
              v-model="movDetail.ledStatus"
              active-color="#45db5e"
              inactive-color="var(--switch-inactive-color)"
              @change="onAction('', 'led')">
            </el-switch>
          </div>
          <div class="line">
            <div class="item" @click="onAction('1')">
              <i class="iconfont icon-qidong"></i>
              <span>启动</span>
            </div>
            <div class="item" @click="onAction('2')">
              <i class="iconfont icon-tingzhi"></i>
              <span>停止</span>
            </div>
            <div class="item" @click="onAction('3')">
              <i class="iconfont icon-dian"></i>
              <span>回充</span>
            </div>
            <div class="item" @click="syncTime">
              <i class="iconfont icon-tongbu"></i>
              <span>同步时间</span>
            </div>
          </div>
        </div>
        <div class="other">
          <p @click="syncInformation"><i class="iconfont icon-tongbu1"></i>同步信息</p>
          <p @click="showMessage = true"><i class="iconfont icon-daiban"></i>作业任务信息</p>
        </div>
      </template>
    </template>
    <p class="tip" v-else>
      <img src="@/assets/img/empty.svg" alt="">
    </p>
    <MovMessage :isShow.sync="showMessage" :movDetail="movDetail"></MovMessage>
  </div>
</template>

<script>
  import MovMessage from './Message'
  export default {
    name: 'Moving',
    components: { MovMessage },
    data () {
      return {
        runStatusList: ['割草', '待机', '回仓', '休眠等待', '充电', '故障'],
        list: [],
        currentIndex: '',
        isOrder: false,
        movDetail: {},
        showMessage: false
      }
    },
    watch: {
      projectId () {
        this.loadData()
      }
    },
    computed: {
      projectId () {
        return this.$store.state.projectId || ''
      }
    },
    created () {
      this.loadData()
    },
    methods: {
      // 获取割草机列表
      loadData () {
        this.$axios.get(this.$apis.moving.selectJgMowingInfoMapByList, {
          projectId: this.projectId
        }).then(res => {
          this.list = res || []
          this.$event.$emit('mov-list-init', this.list)
          if (this.list.length) {
            this.currentIndex = '0'
            this.movChange()
          }
        })
      },
      movChange () {
        if (this.currentIndex) {
          const info = this.list[Number(this.currentIndex)]
          this.movDetail = {
            ...info,
            ledStatus: info.led === '1',
            rainStatus: info.rain === '1'
          }
          this.$event.$emit('mov-change', this.movDetail)
        }
      },
      onAction (motion, type) {
        if (this.isOnlineAndNoAction()) {
          if (type === 'led') {
            let led = '1'
            // led灯控
            if (this.movDetail.led) {
              led = this.movDetail.led === '1' ? '3' : this.movDetail.led === '2' ? '1' : '2'
            }
            this.sendOrder({ led })
          } else if (type === 'rain') {
            // 雨天作业开关
            const rain = this.movDetail.rain === '1' ? '2' : '1'
            this.sendOrder({ rain })
          } else {
            // motion: '1':开启设备; '2':关闭设备； '3':回充；
            this.sendOrder({ motion: motion })
          }
        } else {
          if (type === 'led') {
            this.movDetail.ledStatus = !this.movDetail.ledStatus
          } else if (type === 'rain') {
            this.movDetail.rainStatus = !this.movDetail.rainStatus
          }
        }
      },
      // 发送割草机指令
      sendOrder (data) {
        this.isOrder = true
        const info = {
          deviceNumber: this.movDetail.deviceNumber,
          ...data
        }
        this.$axios.post(this.$apis.moving.insertMowingInstructions, info).then(() => {
          this.$message.success('发送指令成功')
          this.loadData()
        }).finally(() => {
          this.isOrder = false
        })
      },
      // 同步时间
      syncTime () {
        if (this.isOnlineAndNoAction()) {
          this.isOrder = true
          this.$axios.get(this.$apis.moving.insertMowingTime, {
            deviceNumber: this.movDetail.deviceNumber
          }).then(() => {
            this.$message.success('同步时间成功')
            this.$event.$emit('sync-mov-info')
          }).finally(() => {
            this.isOrder = false
          })
        }
      },
      // 同步信息
      syncInformation () {
        if (this.isOnlineAndNoAction()) {
          this.isOrder = true
          this.$axios.get(this.$apis.moving.insertMowingData, {
            deviceNumber: this.movDetail.deviceNumber
          }).then(() => {
            this.$message.success('同步信息成功')
            this.$event.$emit('sync-mov-info')
          }).finally(() => {
            this.isOrder = false
          })
        }
      },
      isOnlineAndNoAction () {
        let status = false
        if (this.movDetail.deviceStatus !== '1') {
          this.$message.warning('设备已离线，暂时无法操作')
        } else if (this.isOrder) {
          this.$message.warning('正在下发指令，请勿重复操作')
        } else {
          status = true
        }
        return status
      }
    }
  }
</script>

<style scoped lang='scss'>
  .content {
    color: var(--font-color);
    min-height: 30px;
    padding: 10px 10px 0;
    .header {
      width: 278px;
      height: auto;
      text-align: center;
      background: #FAFAFA;
      border-radius: 4px;
      border: 1px solid #F4F4F4;
      padding: 10px 12px;
      margin: 0 auto 15px;
      .el-select {
        width: 238px;
        ::v-deep input {
          color: #000;
        }
      }
      .status {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 12px;
        margin-top: 5px;
        i {
          font-size: 12px;
          margin-right: 2px;
          color: rgb(0, 255, 0);
          &.offline {
            color: #999999;
          }
        }
        span {
          display: inline-block;
          height: 16px;
          color: #6BB3AD;
          line-height: 16px;
          text-align: center;
          padding: 0 10px;
          background: rgba(107, 179, 173, 0.1);
          border-radius: 4px;
          &.style1 {
            color: #EC980D;
            background: rgba(236, 152, 13, 0.1);
          }
          &.style2 {
            color: #9B9B9B;
            background: rgba(155, 155, 155, 0.1);
          }
          &.style3 {
            color: #D86262;
            background: rgba(216, 98, 98, 0.1);
          }
        }
      }
    }
    .controlBoard {
      background: #FAFAFA;
      border-radius: 4px;
      padding: 0 10px 20px;
      .item-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 9px 0;
        border-bottom: 1px solid #F3F3F3;
        &:first-child {
          padding-top: 0;
        }
        .name {
          flex-grow: 2;
          text-overflow: ellipsis;
          white-space: nowrap;
          word-break: keep-all;
          overflow: hidden;
          margin: 0 10px;
        }
      }
      .line {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .item {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          width: 60px;
          height: 60px;
          color: #484A59;
          padding: 13px 0 11px;
          background: #FFFFFF;
          box-shadow: 0px 2px 4px 0px rgba(207,207,207,0.77);
          border-radius: 4px;
          margin-top: 10px;
          cursor: pointer;
          .iconfont {
            font-size: 14px;
            color: #000;
            /*opacity: 0.7;*/
            &.icon-qidong {
              color: #45DB5E;
            }
            &.icon-tingzhi {
              color: #DB4545;
            }
            &.icon-dian {
              color: #1FC8FF;
            }
          }
        }
      }
    }
    .other {
      width: 100%;
      height: 40px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      p {
        cursor: pointer;
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #000000;
        i {
          font-size: 14px;
          margin-right: 8px;
        }
      }
    }
    .tip {
      display: flex;
      justify-content: center;
      padding: 20px;
    }
  }
</style>
